<!-- Generic Edit Modals -->
<ng-container *ngFor="let modal of editModals">
  <emerald-modal
    [opened]="modal.opened"
    [closeOnOutsideClick]="true"
    (onDismiss)="modal.onDismiss()"
    [ngClass]="modal.class"
  >
    <div class="modal-body">
      <h3>
        {{ contractorQuarterlyFeedbackUtils.getModalTitle(modal.sectionKey) }}
      </h3>
      <form [formGroup]="modal.formGroup" (ngSubmit)="modal.submitHandler()">
        <div class="form-group" *ngFor="let item of modal.items">
          <label [for]="item.label">{{ item.label }}</label>
          <input
            *ngIf="item.label !== ContractorQuarterly.lastSpotAward"
            [id]="item.label"
            [formControlName]="item.label"
            class="form-input"
            [placeholder]="'Enter ' + item.label"
            [disabled]="item.label === 'PSID'"
          />
          <emerald-datepicker
            *ngIf="item.label === ContractorQuarterly.lastSpotAward"
            [isOutlined]="true"
            [forceRefresh]="true"
            [formControlName]="item.label"
            [maxDate]="currentDate"
          >
          </emerald-datepicker>
        </div>
        <div class="modal-actions">
          <emerald-button
            [type]="'Secondary'"
            [label]="'Cancel'"
            (click)="modal.onDismiss()"
          ></emerald-button>
          <emerald-button
            [type]="'Primary'"
            [label]="'Submit'"
            [disabled]="!(modal.formGroup && modal.formGroup.valid)"
          ></emerald-button>
        </div>
      </form>
    </div>
  </emerald-modal>
</ng-container>

<div class="navigation-breadcrumb">
  <ng-container *ngFor="let item of currentBreadcrumbItems; let last = last">
    <a
      *ngIf="item.route"
      [routerLink]="item.route"
      [queryParams]="
        item.label === 'Contractor List'
          ? vendorListQueryParams
          : item.label === 'Vendor List'
            ? vendorListQueryParams
            : null
      "
      class="breadcrumb-text"
    >
      {{ item.label }}
    </a>
    <span
      *ngIf="!item.route && item.action"
      class="breadcrumb-text clickable"
      (click)="item.action()"
      role="button"
      tabindex="0"
    >
      {{ item.label }}
    </span>
    <span *ngIf="!item.route && !item.action" class="breadcrumb-text">
      {{ item.label }}
    </span>
    <span *ngIf="!last" class="breadcrumb-separator"> / </span>
  </ng-container>
</div>

<div class="contractor-profile">
  <ng-container *ngIf="(!error || hasData) && !loading; else noDataTemplate">
    <div class="profile-banner">
      <div class="profile-banner__avatar">{{ bannerInitials() }}</div>
      <div class="profile-banner__identity">
        <div class="profile-banner__name-row">
          <span class="profile-banner__name">{{ ContractorName }}</span>
          <span class="profile-banner__role" *ngIf="ContractorProfile">{{ ContractorProfile }}</span>
        </div>
        <div class="banner-meta"
             *ngIf="bannerEmpId || bannerManager || bannerL4 || bannerL3">
          <span class="banner-meta__item" *ngIf="bannerEmpId">
            <span class="banner-meta__label">Emp ID</span>{{ bannerEmpId }}
          </span>
          <span class="banner-meta__sep" *ngIf="bannerEmpId && bannerManager">·</span>
          <span class="banner-meta__item" *ngIf="bannerManager">
            <span class="banner-meta__label">Manager</span>{{ bannerManager }}
          </span>
          <span class="banner-meta__sep" *ngIf="bannerManager && bannerL4">·</span>
          <span class="banner-meta__item" *ngIf="bannerL4">
            <span class="banner-meta__label">L4</span>{{ bannerL4 }}
          </span>
          <span class="banner-meta__sep" *ngIf="(bannerManager || bannerL4) && bannerL3">·</span>
          <span class="banner-meta__item" *ngIf="bannerL3">
            <span class="banner-meta__label">L3</span>{{ bannerL3 }}
          </span>
        </div>
      </div>
      <emerald-button
        [type]="'Secondary'"
        [label]="'Release'"
        [size]="'Medium'"
        (click)="openReleaseModal()"
        class="release-btn"
      ></emerald-button>
    </div>

    <!-- Opened from Team Composition's feedback action: the profile tiles
         repeat what the Employee 360 already shows — keep just the header
         bar and the feedback section in that context. -->
    <div class="row-container" *ngIf="navigationSourceTeam !== 'team-composition'">
      <ng-container *ngFor="let section of cardSections">
        <div class="col">
          <emerald-card>
            <div [ngClass]="section.headerClass">
              <i class="icon" [ngClass]="section.iconClass"></i>
              <h2 class="heading-title">
                {{ quarterlyFeedback[section.labelKey] }}
              </h2>
              <span class="about-header-spacer"></span>
              <button
                *ngIf="
                  section.labelKey === 'Performance' ||
                  section.labelKey === 'ISkills'
                "
                class="edit-about-btn"
                (click)="section.editHandler()"
              >
                <i class="material-icons">edit</i>
              </button>
            </div>
            <div class="separator"></div>
            <div class="content-container">
              <p *ngFor="let item of section.items">
                <strong>{{ item.label }}:</strong>
                <span [title]="item.value">{{ item.value }}</span>
              </p>
            </div>
          </emerald-card>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <h2 class="empty-state-title">
          {{ error || ContractorProfileEnum.NoEmployeeFound }}
        </h2>
        <img
          [src]="imageSrc"
          alt="{{ ContractorProfileEnum.NoRecordsIllustration }}"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>

  <emerald-modal
    [opened]="isReleaseModalOpen"
    [closeOnOutsideClick]="true"
    (onDismiss)="closeReleaseModal()"
    class="release-modal"
  >
    <div class="modal-body">
      <h3>{{ ContractorName }}'s Release</h3>
      <form [formGroup]="releaseForm">
        <div class="form-group">
          <label for="comments"></label>
          <textarea
            id="comments"
            formControlName="comments"
            placeholder="Comments"
            class="comments-textbox"
          ></textarea>
        </div>

        <ng-container *ngIf="openForm">
          <emerald-dropdown
            [label]="'Release Type'"
            [outlined]="true"
            [errorText]="'Required field'"
            [isValid]="true"
            formControlName="releaseType"
            [options]="releaseTypeOptions"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
            [id]="'releaseType'"
          ></emerald-dropdown>
        </ng-container>

        <emerald-datepicker
          [label]="'Release Date'"
          [isOutlined]="true"
          [forceRefresh]="true"
          formControlName="releaseDate"
        ></emerald-datepicker>
        <div
          *ngIf="
            releaseForm &&
            releaseForm.get('releaseDate')?.errors?.['invalidDate']
          "
          class="error-message"
        >
          {{ releaseInfo.dateValidation }}
        </div>
        <div
          *ngIf="
            releaseForm &&
            releaseForm.get('releaseDate')?.errors?.['invalidDateFormat']
          "
          class="error-message"
        >
          {{ releaseInfo.errorMessage }}
        </div>
      </form>
    </div>
    <ng-container actions>
      <emerald-button
        [type]="'Secondary'"
        [label]="'Cancel'"
        (click)="closeReleaseModal()"
        class="cancel-btn"
      ></emerald-button>
      <emerald-button
        [type]="'Primary'"
        [label]="'Submit'"
        [disabled]="isDateInvalid || !(releaseForm && releaseForm.valid)"
        (click)="submitRelease()"
        class="submit-btn"
      ></emerald-button>
    </ng-container>
  </emerald-modal>
</div>

<div class="quarterly-feedback-section" *ngIf="(!error || hasData) && !loading">
  <h2 class="quarterly-feedback-title">{{ quarterlyFeedback.Feedback }}</h2>

  <ng-container *ngFor="let box of quarterBoxes">
    <div class="quarter-card">
      <div class="quarter-header">
        <span class="quarter-label">
          {{ box.label }}
        </span>
        <emerald-icon icon="arrow_drop_down"></emerald-icon>
      </div>

      <div class="quarter-content">
        <div *ngIf="box.loading" class="loading-message">
          <span>{{ "Loading" }}...</span>
        </div>
        <div *ngIf="box.error" class="error-message">
          <span>{{ box.error }}</span>
        </div>

        <ng-container *ngIf="!box.loading && !box.error">
          <div
            *ngIf="box.feedbacks?.length === 0 && editingQuarterBox !== box"
            class="no-feedback-container"
          >
            <span class="no-feedback-message">{{
              contractorQuarterlyFeedback.NoFeedback
            }}</span>
            <button class="add-feedback-btn" (click)="onAddFeedback(box)">
              Add Feedback
            </button>
          </div>

          <form
            *ngIf="editingQuarterBox === box"
            (ngSubmit)="submitFeedback()"
            [formGroup]="feedbackForm"
            class="feedback-form-container"
          >
            <div class="rating-row">
              <div class="rating-block performance-rating-block">
                <emerald-dropdown
                  [label]="contractorQuarterlyFeedback.PerformanceLabel"
                  [outlined]="true"
                  [showFilter]="false"
                  [isValid]="true"
                  formControlName="performanceRating"
                  [options]="performanceRatingDropdownOptions"
                  [id]="'perfRating_' + box.year + '_' + box.quarter"
                  [preSelectedLabel]="'label'"
                  [preSelectedValue]="'value'"
                >
                </emerald-dropdown>
                <div
                  *ngIf="submitted && feedbackForm.get('performanceRating')?.invalid"
                  class="error"
                >
                  {{ contractorQuarterlyFeedback.PerformanceError }}
                </div>
              </div>
            </div>

            <!-- Rating scale reference — collapsed by default so the form
                 stays clean. Lives OUTSIDE the width-capped rating block so
                 the description column can stretch full-width and doesn't
                 have to wrap awkwardly under the dropdown. -->
            <div class="perf-rating-legend">
              <button type="button"
                      class="perf-rating-legend__toggle"
                      [attr.aria-expanded]="showRatingScale"
                      (click)="showRatingScale = !showRatingScale">
                <span class="perf-rating-legend__caret" aria-hidden="true">{{ showRatingScale ? '▾' : '▸' }}</span>
                Rating scale
              </button>
              <ul *ngIf="showRatingScale" class="perf-rating-legend__list">
                <li *ngFor="let opt of performanceRatingOptions"
                    [class.perf-rating-legend__item--active]="opt.value === readPerformanceRatingFromForm()">
                  <span class="perf-rating-legend__label">{{ opt.label }}</span>
                  <span class="perf-rating-legend__desc">{{ opt.description }}</span>
                </li>
              </ul>
            </div>

            <div class="feedback-textarea-container">
              <textarea
                formControlName="comments"
                rows="6"
                placeholder="Comments*"
                class="feedback-textarea"
              ></textarea>
              <div
                *ngIf="submitted && feedbackForm.get('comments')?.invalid"
                class="error"
              >
                {{ contractorQuarterlyFeedback.CommentError }}
              </div>
            </div>

            <div class="feedback-btn">
              <button
                type="button"
                class="cancel-feedback-btn"
                (click)="cancelFeedback()"
              >
                Cancel
              </button>
              <button type="submit" class="add-feedback-btn">
                {{ isEditMode ? contractorQuarterlyFeedback.Update : "Submit" }}
              </button>
            </div>
          </form>

          <ng-container *ngIf="box.feedbacks.length > 0">
            <div
              class="feedback-entry"
              [class.entry-latest]="idx === 0 && box.feedbacks.length > 1"
              [class.entry-previous]="idx > 0"
              *ngFor="
                let fb of box.feedbacks;
                trackBy: trackFeedback;
                let idx = index
              "
            >
              <ng-container
                *ngIf="
                  !(isEditMode && editingFeedbackId === fb.contractorFeedbackId)
                  && (fb.performanceRating || (fb.techincalRating || 0) > 0 || (fb.behaviouralRating || 0) > 0)
                "
              >
                <span
                  *ngIf="box.feedbacks.length > 1"
                  class="entry-badge"
                  [class.entry-badge--latest]="idx === 0"
                  [class.entry-badge--previous]="idx > 0"
                >
                  {{ idx === 0 ? 'Latest' : 'Previous' }}
                </span>
                <!-- AB: new-form rows carry performanceRating (bucket letter)
                     and no integer stars. Legacy rows carry the integer
                     technical + behavioural pair; render each shape natively.
                     Legacy block only renders when at least one legacy field
                     is > 0 — post-migration rows (both null) or zero-star
                     rows should not paint an empty widget. -->
                <div class="rating-row" *ngIf="fb.performanceRating">
                  <div class="rating-block performance-rating-block">
                    <span class="rating-label">
                      {{ contractorQuarterlyFeedback.PerformanceLabel }}:
                      <strong>{{ getPerformanceRatingFullDisplay(fb.performanceRating) }}</strong>
                    </span>
                  </div>
                </div>
                <div class="rating-row"
                     *ngIf="!fb.performanceRating
                            && ((fb.techincalRating || 0) > 0 || (fb.behaviouralRating || 0) > 0)">
                  <ng-container *ngFor="let type of ratingTypes">
                    <div class="rating-block">
                      <span class="rating-label">
                        {{ getQuarterlyFeedbackLabel(type) }}
                        ({{ getQuarterRating(fb, type) }}/5)
                      </span>
                      <span class="stars">
                        <ng-container *ngFor="let s of stars; let si = index">
                          <span
                            class="star"
                            [class.filled]="si < getQuarterRating(fb, type)"
                            >&#9733;</span
                          >
                        </ng-container>
                      </span>
                    </div>
                  </ng-container>
                </div>

                <div class="feedback-comment-block">
                  <div class="feedback-comment-label">Comments:</div>
                  <div class="feedback-comment">{{ fb?.comments }}</div>
                </div>

                <div class="feedback-meta-row">
                  <div>
                    <div>
                      {{ ContractorQuarterly.submittedBy }}
                      {{ fb?.submittedBy }}
                    </div>
                    <div>
                      {{ ContractorQuarterly.submittedOn }}
                      {{ formatSubmittedDate(fb?.submittedDate) }}
                    </div>
                  </div>

                  <button
                    *ngIf="canEditFeedback(box, fb)"
                    class="edit-feedback-btn"
                    (click)="onEditFeedback(box, fb)"
                  >
                    <emerald-icon
                      icon="edit"
                      [fontsizeInRem]="1"
                    ></emerald-icon>
                  </button>
                </div>
              </ng-container>

              <div
                class="entry-separator"
                *ngIf="
                  idx < box.feedbacks.length - 1 &&
                  !(isEditMode && editingFeedbackId === fb.contractorFeedbackId)
                "
              ></div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
